// templateViewConfig.js — Task 11 client mirror of the artifact template registry's PRESENTATION
// facts: template_key → { label (badge/chip text), color }. The set of keys MUST stay in lockstep
// with the registries (src/templates/artifactTemplates.ts + app/services/agent/artifact_templates.rb);
// this file adds only the human label + badge color the library/viewer render (never a data contract).
//
// ORDER drives the library filter-chip order (after the "All" chip). generic_report is last (the
// bridge fallback for a templateless report).

export const TEMPLATE_ORDER = [
  "weekly_performance_digest",
  "event_triage",
  "head_to_head",
  "monthly_money_recap",
  "marketing_gap_scan",
  "generic_report",
]

export const TEMPLATE_VIEW = {
  weekly_performance_digest: { label: "Weekly Digest", color: "#5349E5" },
  event_triage: { label: "Event Triage", color: "#1F9D4D" },
  head_to_head: { label: "Head-to-Head", color: "#6A3AFB" },
  monthly_money_recap: { label: "Money Recap", color: "#D97706" },
  marketing_gap_scan: { label: "Gap Scan", color: "#2563EB" },
  generic_report: { label: "Report", color: "#64748B" },
}

// The badge/label facts for a key; unknown keys fall back to the generic_report treatment.
export function badgeFor(key) {
  return TEMPLATE_VIEW[key] || TEMPLATE_VIEW.generic_report
}
